<app-mu-filter-toolbar
  id="mu-filter-toolbar-deliveries"
  [flagList]="flagList"
  [showFlag]="massiveServiceFlags.SHOW_FILTERS"
  [buttonLoaderFlag]="massiveServiceFlags.APPLY_FILTERS"
  [filterFieldList]="filterFieldList"
  [filterList]="filterList"
  [sideBarTitle]="'form.label.filterToolbar.sideBarTitle' | translate"
  [descriptionFilter]="'form.label.filterToolbar.description' | translate"
>
  <ng-template [appMuFilterToolbarField]="'orderId'" let-field>
    <input
      pInputText
      type="text"
      [placeholder]="'form.placeholder.orderId' | translate"
      class="p-inputtext p-component"
      [(ngModel)]="field.filters.model[field.filter]"
    />
  </ng-template>

  <ng-template [appMuFilterToolbarField]="'idLocalities'" let-field>
    <app-mu-multiselect
      [filter]="true"
      [options]="localityList"
      [showToggleAll]="true"
      [filterList]="field.filters"
      [filterName]="field.filter"
      [resetFilterOnHide]="true"
      [placeholder]="'multiSelect.selectLocalitiesDeliveriesFilter'"
    >
    </app-mu-multiselect>
  </ng-template>

  <ng-template [appMuFilterToolbarField]="'idSizes'" let-field>
    <app-mu-multiselect
      [filter]="true"
      [options]="weightList"
      [showToggleAll]="true"
      [filterList]="field.filters"
      [filterName]="field.filter"
      [resetFilterOnHide]="true"
      [placeholder]="'multiSelect.selectSizesDeliveriesFilter'"
    >
    </app-mu-multiselect>
  </ng-template>

  <ng-template [appMuFilterToolbarField]="'startDate'" let-field>
    <app-mu-calendar
      [(ngModel)]="field.filters.model.startDate"
      [placeholder]="'form.placeholder.startDate' | translate"
      [showTime]="false"
    ></app-mu-calendar>
  </ng-template>

  <ng-template [appMuFilterToolbarField]="'dueDate'" let-field>
    <app-mu-calendar
      [(ngModel)]="field.filters.model.dueDate"
      [placeholder]="'form.placeholder.dueDate' | translate"
      [showTime]="false"
    ></app-mu-calendar>
  </ng-template>

  <ng-template [appMuFilterToolbarField]="" let-field>
    <input
      pInputText
      type="text"
      class="p-inputtext p-component"
      [(ngModel)]="field.filters.model[field.filter]"
    />
  </ng-template>
</app-mu-filter-toolbar>
